import React, { useState, useEffect } from 'react';
import Button from '../shared/Button';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  const navLinks = [
    { text: 'Início', href: '#hero' },
    { text: 'Produtos', href: '#consoles' },
    { text: 'Como Funciona', href: '#trade-process' },
    { text: 'Unboxing', href: '#unboxing' },
    { text: 'FAQ', href: '#faq' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    
    if (!isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  const handleHeaderCtaClick = (label) => {
    if (window.fbq) {
      window.fbq('trackCustom', 'HeaderClick', { label });
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="container header-container">
        <div className="logo">
          <a href="#hero" aria-label="Início">
            <span className="logo-gama">GAMA</span>
            <span className="logo-games">GAMES</span>
          </a>
        </div>

        {/* Desktop Menu */}
        <nav className="desktop-nav">
          <ul>
            {navLinks.map((link, index) => (
              <li key={index}>
                <a href={link.href}>{link.text}</a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="header-cta desktop-only">
          <Button 
            href="https://api.whatsapp.com/send/?phone=554799089366" 
            variant="primary" 
            size="md"
            onClick={() => handleHeaderCtaClick('Fale Conosco Desktop')}
          >
            <i className="fab fa-whatsapp mr-2"></i> Fale Conosco
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="menu-toggle" 
          onClick={toggleMenu} 
          aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
        >
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-container">
          <button 
            className="close-menu-button" 
            onClick={closeMenu} 
            aria-label="Fechar menu"
          >
            <i className="fas fa-times"></i>
          </button>
          <nav className="mobile-nav">
            <ul>
              {navLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href} 
                    onClick={closeMenu}
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="mobile-menu-cta">
            <Button 
              href="https://api.whatsapp.com/send/?phone=554799089366" 
              variant="primary" 
              size="lg"
              className="w-full py-4 text-lg"
              onClick={() => handleHeaderCtaClick('Fale Conosco Mobile')}
            >
              <i className="fab fa-whatsapp mr-2"></i> Fale Conosco
            </Button>
          </div>
        </div>
      </div>

      {/* Overlay - Movido para fora do container para cobrir toda a tela exceto o header */}
      <div 
        className={`mobile-menu-overlay ${isMenuOpen ? 'visible' : ''}`} 
        onClick={closeMenu}
      ></div>
    </header>
  );
};

export default Header; 